<template>
  <el-card id="UserInfo">
    <template #header>
      <span>个人信息</span>
    </template>
    <el-form ref="form" label-width="auto">
      <el-row>
        <el-col class="user_info_content" :md="{span:18,offset:3}" :xs="{span:24,offset:0}">
          <el-form-item label="用户头像：">
            <el-avatar :src="headImg"></el-avatar>
            <el-button icon="el-icon-edit" style="float:right;height: 40px;" size="small" @click="show=!show">
              更换头像
            </el-button>

          </el-form-item>
          <el-form-item v-if="show == true">
            <el-upload
                ref="uUpload"
                :action="fileUploadUrl + userSuffix"
                :limit="1"
                list-type="picture-card"
                :data="extraData"
                :on-success="uploadSuccess"
                :on-remove="imgRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="用户昵称：">
            <span style="float:left;">{{ userName }}</span>
            <el-button style="float:right;height: 40px;" icon="el-icon-edit" size="small" @click="showNickName">修改昵称
            </el-button>
          </el-form-item>
          <el-form-item label="手机号：">
            <span style="float:left;">{{ telephone }}</span>
            <el-button icon="el-icon-edit" style="float:right;height: 40px;" size="small" @click="openTelBindDialog">
              {{ bindTelInfo }}
            </el-button>
          </el-form-item>
          <div style="text-align: center">
            <el-button style="width: 100%;" type="primary" icon="el-icon-edit" size="small" @click="showPasswordChange">
              登录密码修改
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog title="修改昵称" :visible.sync="nickNameShow">
      <el-form>
        <el-form-item label="昵称" label-width="120px">
          <el-input v-model="userName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nickNameShow=false">取 消</el-button>
        <el-button type="primary" @click="updateNickName">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="bindTelInfo" :visible.sync="user_tel_dialog" :modal-append-to-body="false" :append-to-body="true"
               custom-class="pcPersonCenter_dialog">
      <el-row>
        <el-col class="user_tel_inputGroup" :md="{span:20,offset:2}" :xs="{span:24,offset:0}">
          <el-form label-width="140px" label-position="left">
            <el-form-item label="手机号码：">
              <el-input placeholder="手机号码" prefix-icon="el-icon-warning" v-model="new_tel"></el-input>
            </el-form-item>
            <el-form-item label="确认手机号码：">
              <el-input placeholder="确认手机号码" prefix-icon="el-icon-warning" v-model="double_tel_confirm"></el-input>
            </el-form-item>
            <el-form-item label="短信验证码：">
              <el-input class="input" v-model="captcha">
                <template #append>
                  <el-button type="primary" class="sendCodeBtn" v-if="!getCodeDisabled" @click="get_code">{{
                      getCaptcha
                    }}
                  </el-button>
                  <el-button type="primary" class="sendCodeBtn" disabled v-else>{{ clock }}</el-button>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="图形验证码：" v-show="needImgVerifyCode">
              <div class="imgVerifyCode" style="">
                <el-input class="imgVerifyCode_input" v-model="imgVerifyCode">
                  <img slot="suffix" id="imgVerifyCode" alt="点击更换" title="点击更换" @click="changeImg"/>
                </el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="user_tel_dialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="resetTel" size="small">确 认</el-button>
      </span>
    </el-dialog>
    <ResetPassword v-if="passwordChangeShow == true" @returnBack="returnBack" :companyTel="telephone"></ResetPassword>
  </el-card>
</template>

<script>
import API from "../../../../../config/api";
import DOMAIN_PREFIX from "../../../../../config/domainPrefix.js"
import axiosRequest from "../../../../../config/axiosRequest";
import ResetPassword from "@/pages/userCenter/ChildComps/ResetPassword";

const AVATAR_PREFIX = DOMAIN_PREFIX.AVATAR_PREFIX
export default {
  components: {
    ResetPassword
  },
  data() {
    return {
      headImg: '',
      border: true,

      show: false,//头像更换的展示
      userName: '',
      telephone: '',
      radio: 0,  //性别
      extraData: {
        flag: 3
      },
      userid: '',
      fileList: [],
      graph: "",
      choice: '',
      userData: [],
      fileUploadUrl: API.fileUpload,
      nickNameShow: false,
      user_tel_dialog: false,//修改绑定手机号展示对话框
      passwordChangeShow: false,//修改密码对话框展示
      //绑定手机修改
      needImgVerifyCode: false,
      imgVerifyCode: '',
      captcha: '', //验证码
      getCodeDisabled: false,
      getCaptcha: '获取验证码',
      clock: '',
      double_tel_confirm: "",
      new_tel: "",
    }
  },
  mounted() {
    this.getUserInfo();
    this.userId = window.localStorage.getItem('userid');
    console.log('个人信息userId的值=', this.userId);
  },
  computed: {
    bindTelInfo() {
      if (this.telephone) {
        return '更改绑定手机'
      } else {
        return '绑定手机'
      }
    },
  },
  methods: {
    //展示修改密码对话框
    showPasswordChange() {
      this.passwordChangeShow = true;
    },
    //消除修改密码对话框
    returnBack(){
      this.passwordChangeShow = false;
    },
    uploadSuccess(data) {
      let self = this;
      console.log("data = ", data);
      this.graph = data; //this.graph变为上传的图片
      if (!this.headImg || this.headImg == 'undefined') {
        self.$message({type: 'warning', message: '请上传头像'});
        return
      }
      this.headImg = AVATAR_PREFIX + this.graph + this.userSuffix;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      this.$axiosRequest({
        url: API.updateUserInfo,
        method: 'POST',
        data: {
          headImg: this.graph,
        },
        header: header,
        success: res => {
          console.log('res.data=', res.data)
          if (res.data > 0) {
            self.$message({type: 'success', message: '头像修改成功'});
            self.getUserInfo();
            self.show = false;
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '保存失败'});
          }
        }
      });
    },
    //展示修改昵称的对话框
    showNickName() {
      this.nickNameShow = true;
    },
    //修改昵称
    updateNickName() {
      let self = this;
      if (!this.userName || this.userName == 'undefined') {
        self.$message({type: 'warning', message: '请输入昵称'});
        return
      }
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      this.$axiosRequest({
        url: API.updateUserInfo,
        method: 'POST',
        data: {
          nickname: this.userName,
        },
        header: header,
        success: res => {
          console.log('res.data=', res.data)
          if (res.data > 0) {
            self.$message({type: 'success', message: '昵称修改成功'});
            self.getUserInfo();
            self.nickNameShow = false;
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '保存失败'});
            self.nickNameShow = false;
          }
        }
      });
    },
    //修改绑定手机对话框
    openTelBindDialog() {
      this.user_tel_dialog = true;
    },
    //修改绑定手机号
    resetTel() {
      let self = this;
      if (this.new_tel == '') {
        self.$message({type: 'warning', message: '手机号不能为空'});
      } else if (this.double_tel_confirm == '') {
        self.$message({type: 'warning', message: '确认手机号不能为空'});
      } else if (this.new_tel != this.double_tel_confirm) {
        self.$message({type: 'warning', message: '手机号和确认手机号需一致'});
      } else if (this.captcha == '') {
        self.$message({type: 'warning', message: '验证码不能为空'});
      } else {
        // 进行重置操作
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {
          bindingTel: this.telephone,
          value: this.new_tel,
          smsVerifyCode: this.captcha,

        }
        this.$axiosRequest({
          url: API.updateUserInfo,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data > 0) {
              self.$message({type: 'success', message: '重置成功'});
              this.user_tel_dialog = false;
              this.getUserInfo();
            } else if (res.data == -2) {
              self.$message({type: 'warning', message: '验证码不正确'});
              this.user_tel_dialog = false;
            } else if (res.data == -3) {
              self.$message({type: 'warning', message: '手机号已注册'});
              this.user_tel_dialog = false;
            } else if(res.data ==-1){
              self.$message({type: 'warning', message: '执行出错'});
              this.user_tel_dialog = false;
            }
          }
        });


      }
    },
    imgRemove() {

    },
    async getUserInfo() {
      let data = await axiosRequest({
        url: API.getUserInfo,
        method: 'POST',
        data: {},
        header: API.header,
      });
      console.log(data)
      this.userName = data[1].data.userInfo.nickname
      this.telephone = data[1].data.userInfo.bindingTel

      if (!data[1].data.userInfo.headImg || data[1].data.userInfo.headImg == '') {
        this.headImg = AVATAR_PREFIX + '/static/logo.png' + this.userSuffix;
      } else {
        this.headImg = AVATAR_PREFIX + data[1].data.userInfo.headImg + this.userSuffix;
        this.graph = data[1].data.userInfo.headImg
      }
      this.radio = data[1].data.userInfo.sex;
      console.log('头像的值=', this.headImg)

    },
    //修改绑定手机
    // 获取验证码
    get_code() {
      let self = this;
      if (self.needImgVerifyCode && self.imgVerifyCode == '') {
        self.$message({type: 'warning', message: '图片验证码不应该为空'});
      } else if (self.new_tel == '') {
        self.$message({type: 'warning', message: '手机号不能为空'});
      } else {
        self.getCodeDisabled = true;
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }
        let data = {
          type: 2,
          phoneNumber: self.new_tel,
          imgVerifyCode: self.imgVerifyCode
        }
        this.$axiosRequest({
          url: API.sendCode,
          method: 'GET',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.$message({type: 'success', message: '验证码发送成功'});
              self.testIfNeedImgVerifyCode();// 每次验证码发送成功后，测试下一次是否需要图片验证码
            } else if (res.data == 1) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
            } else if (res.data == 2) {
              self.$message({type: 'warning', message: '请先输入图片验证码后才可获取短信验证码'});
            } else {
              self.$message({type: 'warning', message: '获取验证码失败，请稍后再试'});
            }
          }
        });
        let time = 59;
        self.clock = time + "s后重新发送";
        let cleartime = setInterval(() => {
          if (time <= 0) {
            self.clock = "重新获取";
            self.getCodeDisabled = false;
            clearInterval(cleartime);
            return false;
          }
          time -= 1;
          self.clock = time + "s后重新发送";
        }, 1000);
      }
    },
    changeImg() {
      let imgVerifyCode = document.getElementById("imgVerifyCode");
      imgVerifyCode.src = this.$axios.defaults.baseURL + "/message/getImgVerifyCode?time=" + Math.random(1000) + "&phoneNumber=" + this.new_tel;
      console.log("change: imgVerifyCode.src:", imgVerifyCode.src);
    },
    testIfNeedImgVerifyCode() {
      let self = this;
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.new_tel)) {
        return
      }
      if (!self.needImgVerifyCode) {// 如果needImgVerifyCode已经为true了，就不要再调用接口判断了，直接更换验证码图片
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {}
        this.$axiosRequest({
          url: API.testIfNeedImgVerifyCodeSend,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.needImgVerifyCode = true;
              self.changeImg();
            }
          }
        });
      } else {
        self.changeImg();
      }
    },
  }
}
</script>

<style scoped lang="less">
#UserInfo {
  .pcPersonCenter_dialog {
    padding: 0px 0px 20px 0px;

    &.el-dialog {
      width: 576px;
    }

    &.el-dialog__body {
      padding: 10px !important;
    }
  }

  .input {
    float: left;
  }

  .sendCodeBtn {
    float: right;
  }
  .imgVerifyCode {
    position: relative;
    margin: 0 auto;
    .imgVerifyCode_input {
      display: inline-block;
    }
    img {
      display: inline-block;
      height: 38px;
      border-radius: 0 4px 4px 0;
      border-left: 1px solid #C0C4CC;
      margin: 1px 0;
      left: 4px;
      position: relative;
    }
  }
}
</style>